var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 232,
    viewBox: "0 0 238 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2668_6021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.23 232.175C184.867 232.175 237.265 229.001 237.265 225.085C237.265 221.169 184.867 217.995 120.23 217.995C55.5937 217.995 3.19531 221.169 3.19531 225.085C3.19531 229.001 55.5937 232.175 120.23 232.175Z",
    fill: "#FFCA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.618 26.9353L151.863 29.6803",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.792 12.9153L159.047 24.4253",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4453 0.250244V14.2802",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0859 19.5801L12.9209 23.5201",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 10.1753L8.04594 16.7353",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6016 113.53H19.4216",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.253906 113.53H10.1789",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38938 197.91L4.35938 201.48",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9722 184.715L12.2422 195.885",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.156 190.185L150.496 205.93",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.039 186.765L134.809 188.705",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.594 113.53H154.259",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.066 71.6151L144.391 67.3951L145.656 52.5351C146.231 48.0601 143.116 43.9551 138.656 43.3001L33.5611 27.9351C24.5261 26.6151 16.7461 34.3201 17.9811 43.3701L35.5711 172.17C36.6061 179.755 43.0861 185.41 50.7461 185.41H116.091C123.206 185.41 129.216 180.125 130.126 173.07L142.996 76.1901L156.066 71.6151Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1741 24.5251H70.9291C62.1941 24.5251 55.3591 32.0451 56.1941 40.7401L66.8191 151.81C67.5441 159.405 73.9241 165.205 81.5541 165.205C89.1841 165.205 95.5641 159.405 96.2891 151.81L106.914 40.7401C107.744 32.0451 100.909 24.5251 92.1791 24.5251H92.1741Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6679 196.007C101.355 187.106 97.1279 176.901 88.2267 173.214C79.3255 169.527 69.1207 173.754 65.4337 182.655C61.7467 191.556 65.9737 201.761 74.8749 205.448C83.7761 209.135 93.9809 204.908 97.6679 196.007Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2327 21.0852H73.9877C65.2527 21.0852 58.4177 28.6052 59.2527 37.3002L69.8777 148.37C70.6027 155.965 76.9827 161.765 84.6127 161.765C92.2427 161.765 98.6227 155.965 99.3477 148.37L109.973 37.3002C110.803 28.6052 103.968 21.0852 95.2377 21.0852H95.2327Z",
    fill: "#FFCA00",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8531 203.338C94.4866 203.197 102.182 195.273 102.04 185.639C101.899 176.006 93.9751 168.311 84.3416 168.452C74.708 168.593 67.0129 176.517 67.1542 186.151C67.2954 195.784 75.2195 203.479 84.8531 203.338Z",
    fill: "#FFCA00",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.615 25.3802C278.615 25.3802 271.622 23.4864 258.44 29.6739C245.259 35.8427 239.915 51.4989 239.915 62.6176C239.915 73.7364 248.559 91.0239 246.909 94.3239C245.259 97.6239 232.509 101.73 229.622 111.611C226.734 121.493 230.034 139.605 230.034 139.605C230.034 139.605 206.165 172.549 211.097 192.293C216.028 212.036 290.972 245.805 321.834 237.986C352.715 230.168 374.109 188.58 372.065 177.461C370.003 166.343 356.428 158.936 356.84 153.593C357.253 148.249 370.453 139.961 357.947 111.78C352.603 99.7427 339.553 96.7802 339.14 91.8302C338.728 86.8989 343.678 61.7739 333.384 44.0739C323.09 26.3739 291.797 10.5489 278.634 25.3802H278.615Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.81 110.262C266.81 110.262 266.51 123.405 263.135 130.137C261.653 133.099 257.528 130.418 251.51 128.599C232.253 122.787 214.178 127.605 207.766 133.118C201.353 138.612 156.447 179.955 156.447 179.955C156.447 179.955 141.578 221.562 150.447 227.055C159.316 232.549 167.041 229.268 168.26 227.749C169.478 226.212 209.716 182.862 209.716 182.862C209.716 182.862 207.672 194.037 210.541 208.062C211.741 213.874 216.053 238.268 216.053 238.268C216.053 238.268 209.641 257.224 212.378 260.28C215.116 263.337 233.472 274.343 261.897 274.643C290.322 274.943 305.603 271.287 310.497 270.049C315.391 268.812 318.447 266.993 318.447 264.855C318.447 262.718 316.309 258.743 316.309 258.743L326.097 204.705C335.941 238.437 350.922 269.955 347.341 261.237C349.478 266.43 360.147 288.162 362.903 295.493C365.66 302.824 368.716 310.474 372.991 312.612C377.266 314.749 391.328 312.612 396.522 309.855C401.716 307.099 403.253 296.712 400.497 286.005C397.741 275.299 385.891 260.355 383.866 255.124C368.809 215.974 361.835 200.58 360.635 189.705C359.51 179.524 354.128 159.293 335.491 149.524C316.853 139.737 308.36 144.48 301.328 141.724C294.297 138.968 292.46 137.749 292.46 137.749L296.734 114.818L266.772 110.224L266.81 110.262Z",
    fill: "#EBEBEB",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.734 182.861L215.716 165.368",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.441 93.0862C199.441 93.0862 206.716 82.0049 211.179 75.7987C215.623 69.5924 215.979 65.8237 218.36 67.1737C220.76 68.5237 221.435 70.9424 219.391 75.5362C217.329 80.1299 210.148 90.6487 209.81 91.9987C209.473 93.3487 208.273 96.3674 208.273 96.3674L199.441 93.0862Z",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.436 97.0425C211.436 97.0425 216.405 92.0737 220.043 92.3362C223.699 92.5987 224.486 95.4675 221.618 97.8112C218.749 100.155 210.649 109.567 210.386 112.961C210.124 116.355 211.436 97.0425 211.436 97.0425Z",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.002 94.5862C200.696 90.8925 198.952 90.33 196.571 92.6925C193.946 95.3175 187.927 99.6487 186.634 101.73C185.321 103.811 184.29 106.942 183.24 110.861C182.771 112.642 182.19 117.124 181.684 121.474L176.34 135.742L187.815 140.842L193.421 135.686C194.527 134.936 195.765 133.961 196.29 133.042C197.34 131.224 198.634 126.78 198.634 126.78C198.634 126.78 200.452 125.992 203.077 124.961C205.684 123.911 209.602 119.992 210.127 116.355C210.652 112.699 213.259 105.649 214.046 102.517C214.834 99.3862 210.24 97.53 206.002 94.5862Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.633 101.73L200.47 107.73C200.47 107.73 203.339 109.549 202.552 112.174C201.764 114.78 202.027 123.143 200.977 123.93C199.927 124.718 197.583 125.242 196.533 124.98C195.483 124.717 195.033 122.468 195.295 121.174C195.558 119.861 195.895 116.018 195.895 116.018L193.477 116.917",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.712 120.199C201.712 120.199 204.394 121.886 205.425 119.749C206.794 116.917 208.294 111.386 209.081 109.305C209.869 107.224 209.606 104.599 208.556 103.83C207.506 103.061 193.406 95.73 193.406 95.73",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.422 119.749C205.422 119.749 209.659 119.186 211.253 111.911",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.452 127.718L176.902 128.205C181.871 133.699 188.883 136.905 196.271 137.037L191.602 146.599C191.602 146.599 194.396 151.737 194.171 155.224C193.946 158.73 190.215 168.518 185.302 179.018C180.408 189.518 174.09 220.98 168.258 227.749C162.427 234.518 146.902 241.53 138.502 238.962C130.102 236.393 127.965 226.155 130.515 215.655C133.083 205.155 157.777 147.987 161.508 144.03C165.24 140.074 169.196 138.199 170.133 137.505C171.071 136.812 176.433 127.718 176.433 127.718H176.452Z",
    fill: "#EBEBEB",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.602 140.562C173.602 140.562 178.57 145.924 186.989 147.443",
    stroke: "#263238",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2668_6021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238.19,
    height: 232.175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoIcon3);
export default __webpack_public_path__ + "static/media/twoIcon3.71769c5e22122e45897cb698afc4ebc5.svg";
export { ForwardRef as ReactComponent };